import React, {Component} from 'react';
// import Card from 'react-material-card';
import I18n from 'app/common/i18n';
import PrimaryStatsGroup from './PrimaryStatsGroup';
import {SelectField} from 'dk-ui-lib';
import RecentStatsGroup from './RecentStatsGroup';

class DashboardView extends Component {

  handleTimePeriodChange(tiemPeriod) {
    if (!tiemPeriod)
      return;
    this.props.setTimePeriod(tiemPeriod);
    this.props.fetchEntitiesCount(tiemPeriod);
  }

  renderPrimaryStats() {
    let {entity: {entitiesCount}, candidates: {candidatesCount}} = this.props;
    let primaryStats = {
      candidatesCount: candidatesCount.totalCount,
      entitiesCount: entitiesCount.totalCount
    };
    return (
      <div>
        <div className='h3 main-heading normal-letter-spacing pb2'>{I18n.t('dashboard.onboarding')}</div>
        <PrimaryStatsGroup stats={primaryStats}/>
        <hr/>
      </div>
    );
  }

  renderRecentsStats() {
    let {candidates: {candidatesCount}, entity: {timePeriod, recentEntities, entitiesCount}} = this.props;

    let recentStats = {
      candidatesCount: candidatesCount.timePeriodBasedCount,
      entitiesCount: entitiesCount.timePeriodBasedCount,
      entities: recentEntities,
      selectedTimePeriod: timePeriod.selected
    };

    return (
      <div>
        <div className='flex justify-between'>
          <div className='sub-heading'>
            {I18n.t('dashboard.recently_onboarded')}
          </div>
          <div className='col-2'>
            <SelectField
              searchable={false}
              options={timePeriod.options}
              value={timePeriod.selected}
              simpleValue
              onChange={(value) => this.handleTimePeriodChange(value)}
              clearable={false}
            />
          </div>
        </div>
        <RecentStatsGroup
          stats={recentStats}
          className='pt3'
        />
      </div>
    );
  }

  render() {
    return (
      <div level={1} className='px4 py3 white-background'>
        {this.renderPrimaryStats()}
        {this.renderRecentsStats()}
      </div>
    );
  }

}

export default DashboardView;


// WEBPACK FOOTER //
// ./src/views/dashboard/index.js